(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hc-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
  function ready(fn){if(document.readyState!=='loading'){fn();}else{document.addEventListener('DOMContentLoaded',fn);}}
  ready(function(){
    document.querySelectorAll('.hc-pc__wish').forEach(function(w){w.addEventListener('click',function(){w.classList.toggle('is-on');w.innerHTML=w.classList.contains('is-on')?'♥':'♡';});});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-deals"] && !Shopify.designMode) return;
  try {
    
(function(){
  function pad(n){return String(n).padStart(2,'0');}
  function tick(el){
    var resetHours = parseInt(el.getAttribute('data-reset-hours')||'24',10);
    var h=el.querySelector('[data-h]'),m=el.querySelector('[data-m]'),s=el.querySelector('[data-s]');
    var windowMs = resetHours*3600*1000;
    function update(){
      var now=Date.now();
      var remaining = windowMs - (now % windowMs);
      var hrs=Math.floor(remaining/3600000);
      var mins=Math.floor((remaining%3600000)/60000);
      var secs=Math.floor((remaining%60000)/1000);
      if(h)h.textContent=pad(hrs);
      if(m)m.textContent=pad(mins);
      if(s)s.textContent=pad(secs);
    }
    update();
    setInterval(update,1000);
  }
  function init(){document.querySelectorAll('[data-hc-countdown]').forEach(tick);}
  if(document.readyState!=='loading'){init();}else{document.addEventListener('DOMContentLoaded',init);}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-pdp-main"] && !Shopify.designMode) return;
  try {
    
(function(){
  function ready(fn){if(document.readyState!=='loading'){fn();}else{document.addEventListener('DOMContentLoaded',fn);}}
  ready(function(){
    var main=document.getElementById('hcPdpMainImg');
    document.querySelectorAll('.hc-pdp__thumb').forEach(function(t){
      t.addEventListener('click',function(){
        var src=t.getAttribute('data-img');
        if(src&&main){main.src=src;}
        document.querySelectorAll('.hc-pdp__thumb').forEach(function(x){x.classList.remove('is-active');});
        t.classList.add('is-active');
      });
    });
    var qin=document.querySelector('[data-qinput]');
    var qminus=document.querySelector('[data-qminus]');
    var qplus=document.querySelector('[data-qplus]');
    function q(){return Math.max(1,parseInt(qin&&qin.value||'1',10)||1);}
    if(qminus)qminus.addEventListener('click',function(){if(qin)qin.value=Math.max(1,q()-1);});
    if(qplus)qplus.addEventListener('click',function(){if(qin)qin.value=q()+1;});
    var buy=document.querySelector('[data-buynow]');
    var form=document.getElementById('hcPdpForm');
    if(buy&&form){
      buy.addEventListener('click',function(){
        var id=form.querySelector('[name="id"]').value;
        buy.disabled=true;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:q()})})
          .then(function(r){return r.json();})
          .then(function(){window.location.href='/checkout';})
          .catch(function(){buy.disabled=false;window.location.href='/cart';});
      });
    }
    var sh=document.querySelector('[data-share]');
    if(sh)sh.addEventListener('click',function(){
      if(navigator.share){navigator.share({title:document.title,url:window.location.href});}
      else{navigator.clipboard&&navigator.clipboard.writeText(window.location.href);sh.textContent='✓ Link copied';setTimeout(function(){sh.innerHTML='↗ Share';},1800);}
    });
    var w=document.querySelector('[data-wish]');
    if(w)w.addEventListener('click',function(){w.classList.toggle('is-on');w.innerHTML=w.classList.contains('is-on')?'♥ Wishlisted':'♡ Add to Wishlist';});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
(function(){
  function ready(fn){if(document.readyState!=='loading'){fn();}else{document.addEventListener('DOMContentLoaded',fn);}}
  function stripA(s){return (s||'').replace(/\s*\[ASSUMED[^\]]*\]/g,'').replace(/\s+/g,' ').trim();}
  function collectText(node,arr){if(!node)return;if(node.type==='text'&&node.value!=null){arr.push(node.value);}if(node.children){node.children.forEach(function(c){collectText(c,arr);});}}
  ready(function(){
    document.querySelectorAll('[data-hcspec]').forEach(function(el){
      try{var d=JSON.parse(el.textContent.trim());var t=[];collectText(d,t);t=t.map(stripA);
        var rows='';for(var i=2;i+1<t.length;i+=2){if(!t[i])continue;rows+='<div class="hc-specrow"><span class="hc-specrow__k">'+t[i]+'</span><span class="hc-specrow__v">'+(t[i+1]||'')+'</span></div>';}
        if(rows){el.innerHTML=rows;}}catch(e){}
    });
    document.querySelectorAll('[data-hcrich]').forEach(function(el){
      try{var d=JSON.parse(el.textContent.trim());var t=[];collectText(d,t);var html=t.map(function(x){x=stripA(x);return x?'<p>'+x+'</p>':'';}).join('');if(html){el.innerHTML=html;}}catch(e){}
    });
    var tabs=document.querySelectorAll('.hc-tabs__tab');
    var panels=document.querySelectorAll('.hc-tabs__panel');
    tabs.forEach(function(t){
      t.addEventListener('click',function(){
        var key=t.getAttribute('data-tab');
        tabs.forEach(function(x){x.classList.remove('is-active');});
        t.classList.add('is-active');
        panels.forEach(function(pl){pl.classList.toggle('is-active',pl.getAttribute('data-panel')===key);});
        if(key==='reviews' && window.hcGoToReviews){ window.hcGoToReviews(false); }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
